import React from "react";
import { styled } from "@mui/system";
import MUIBadge from "@mui/material/Badge";
import { BadgeProps as BadgePropsMUI } from "@mui/material/Badge";
export interface BadgeProps extends BadgePropsMUI {
  component?: React.ElementType;
}

export const Badge: (props: BadgeProps) => JSX.Element = styled(
  React.forwardRef<HTMLSpanElement, BadgeProps>((props, ref) => (
    <MUIBadge ref={ref} {...props} />
  )),
  {
    name: "Badge",
    slot: "Root",
    overridesResolver: (props, styles) => []
  }
)(({ theme }) => ({
  "&.MuiBadge-root .MuiBadge-badge": {
    ...theme.typography["caption"],
    backgroundColor: theme.palette.primary.baseCriticalColor,
    border: "1px solid" + theme.palette.primary.baseWhiteColor,
    color: theme.palette.primary.baseWhiteColor
  },
  "&.MuiBadge-root .MuiBadge-anchorOriginTopRightRectangular": {
    top: -2,
    right: -5
  },
  "&.MuiBadge-root > .MuiSvgIcon-root": {
    color: theme.palette.primary.iconDefault
  },
  "&.MuiBadge-root .MuiBadge-colorSecondary": {
    backgroundColor: theme.palette.primary.neutral10Color,
    color: "black"
  }
}));
